import styled from 'styled-components';

const StyledLabel = styled.div`
  color: ${(props) => props.theme.colors.white};
  background: ${(props) => props.theme.colors.primary};
  border-radius: 4px;
  display: inline-block;
  font-weight: bold;
  padding: 1px 7px 0;
  height: 25px;
`;

export default StyledLabel;
